import { useState, useEffect } from 'react';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { locationGeoCoderFactory } from '../utils/LocationGeoCoderFactory.js';

const useLocations = (address, icon) => {
  const sdk = useSdk();
  const [loading, setLoading] = useState(true);
  const [buyerMarker, setBuyerMarker] = useState();
  useEffect(() => {
    if (!icon) {
      setBuyerMarker(undefined);
      setLoading(false);
      return;
    }
    const street = address.street1 || '';
    locationGeoCoderFactory(sdk).getLocation(street, address.zipCode, address.city).then(locationPostalCode => {
      const buyerMarker = {
        id: 'buyerId',
        position: new google.maps.LatLng(locationPostalCode.lat, locationPostalCode.lng),
        icon
      };
      setBuyerMarker(buyerMarker);
    }).catch(() => setBuyerMarker(undefined)).finally(() => setLoading(false));
  }, [icon, address, sdk]);
  return [buyerMarker, loading];
};

export { useLocations };
//# sourceMappingURL=useLocations.js.map
